import { Component } from "@kluntje/core";

class FRAScreenSetOverlay extends Component {
  constructor() {
    super({
      ui: {
        overlay: ".fra-m-overlay :-one",
        actionButton: ".fra-e-button :-one",
      },
    });
  }

  /**
   * init action button to open screenset overlay
   */
  afterComponentRender(): void {
    const overlayElem = this.ui.overlay;

    this.ui.actionButton.addEventListener("click", function () {
      overlayElem.open();

      const screenSet = overlayElem.querySelector("fra-m-screenset");
      screenSet.afterComponentRender();
    });
  }
}

customElements.define("fra-m-screenset-overlay", FRAScreenSetOverlay);

export default FRAScreenSetOverlay;
